/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable @next/next/no-img-element */
import React from "react";
import { Rating } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import PlayStoreLogo from "../../../Icons/PlayStoreLogo";
import AppStoreLogo from "../../../Icons/AppStoreLogo";

export default function Premium() {
  // const { userData } = useStore();
  // const router = useRouter();
  // const isUserLoggedIn = userData?.phone;
  // const isCurrentUserPremium = userData?.is_premium;
  const data = {
    mainContent: (
      <h6 className="text-[28px] font-inter leading-[35px] md:text-[30px] lg:!text-[40px]">
        Unlock{" "}
        {/* <span className="text-teal-300 font-inter !font-bold">Kamaai</span> aur{" "} */}
        <span className="font-inter"> Premium</span>{" "}
        <span className="text-yellow-500 !font-bold font-inter">
          Edutainment
        </span>
      </h6>
    ),
    feature: [
      {
        title: "Ad Free Content",
        icon: "assets/landing/AdFrame.webp",
      },
      {
        title: "Unlimited Videos",
        icon: "assets/landing/ImageFrame.webp",
      },
      {
        title: "HD Quality",
        icon: "assets/landing/VideoFrame.webp",
      },
    ],
    footerText: "Start Today!",
    ratings: "4.5 Ratings",
    userBase: "7.3 Lakh+ review | 1Cr+ Bharat Users",
  };

  // const handleRedirectToSeries = () => {
  //   if (isUserLoggedIn) {
  //     if (isCurrentUserPremium) {
  //       router.push("/app");
  //     } else {
  //       router.push("/premium");
  //     }
  //   } else {
  //     router.push("/login");
  //   }
  // };

  return (
    // OLD CODE
    // <div className={styles.premium_section}>
    //   <div className={styles.premium_section_column}>
    //     <img
    //       alt="seekho"
    //       src={seekhoAppPremiumIconURL}
    //       className={styles.premium_section_img}
    //     />
    //     <div className={styles.premium_section_title}>
    //       <span className={styles.premium_section_title_top}>
    //         Start today only at
    //       </span>
    //       <span className={styles.premium_section_title_price}>
    //         ₹{startPrice}
    //       </span>
    //     </div>
    //     <div className={styles.premium_section_benefits}>
    //       <div className={styles.premium_section_benefits_list}>
    //         <img
    //           alt="seekho"
    //           src="assets/landing/AdFrame.webp"
    //           className={styles.premium_benefits_img}
    //         />
    //         <span className={styles.premium_benefits_text}>
    //           Ad Free Content
    //         </span>
    //       </div>
    //       <div className={styles.premium_section_benefits_list}>
    //         <img
    //           alt="seekho"
    //           src="assets/landing/ImageFrame.webp"
    //           className={styles.premium_benefits_img}
    //         />
    //         <span className={styles.premium_benefits_text}>
    //           Unlimited Videos
    //         </span>
    //       </div>
    //       <div className={styles.premium_section_benefits_list}>
    //         <img
    //           alt="seekho"
    //           src="assets/landing/VideoFrame.webp"
    //           className={styles.premium_benefits_img}
    //         />
    //         <span className={styles.premium_benefits_text}>HD Quality</span>
    //       </div>
    //     </div>
    //     <div
    //     // className={styles.subscribetoplus}
    //     // onClick={handleRedirectToSeries}
    //     >
    //       {/* <div className={styles.start_learning}>
    //         {isCurrentUserPremium ? "Explore More" : "Subscribe to Plus"}
    //         <img
    //           alt="seekho"
    //           src="assets/longArrow.svg"
    //           className={styles.img_google}
    //         />
    //       </div> */}
    //       {/* Mobile */}
    //       <div>
    //         <DownloadTheAppCTA
    //           onSection="Pricing"
    //           className="w-full !px-10 !rounded-full font-medium"
    //         />
    //       </div>
    //     </div>
    //   </div>
    // </div>
    // NEW DESIGN CODE
    <div className="border-b border-gray-700 pb-10 md:!mt-0 lg:pb-20 lg:!mt-24">
      <div className="text-center w-[80%] mx-auto md:w-[60%] lg:w-[30%]">
        {data.mainContent}
        <div className="w-fit mx-auto !mt-5 lg:!mt-8">
          {data?.feature?.map((item) => {
            return (
              <div className="flex items-center gap-x-3 mt-2">
                <img
                  src={item?.icon}
                  alt={item?.title}
                  className="w-[31px] h-[31px]"
                />
                <h6 className="mt-2 text-[20px] font-inter">{item?.title}</h6>
              </div>
            );
          })}
        </div>
        <h6 className="text-[48px] font-inter !font-bold !mt-4 lg:!mt-8">
          {data?.footerText}
        </h6>

        <div className="flex w-fit mx-auto gap-x-4 mt-8 items-center">
          <PlayStoreLogo className="w-[110px] lg:w-[140px]" />
          <AppStoreLogo className="w-[110px] lg:w-[140px]" />
        </div>

        <div className="mt-4 w-fit mx-auto">
          <Rating
            name="half-rating-read"
            defaultValue={4.5}
            precision={0.1}
            readOnly
            icon={<FontAwesomeIcon icon={faStar} style={{ fontSize: 25 }} />}
            emptyIcon={
              <FontAwesomeIcon
                icon={faStar}
                style={{ color: "rgba(0,0,0,0)", fontSize: 25 }}
              />
            }
          />
          <h6 className="text-[30px] font-inter mt-1">{data?.ratings}</h6>
          <h6 className="text-[15px] font-inter tracking-wide text-gray-300 font-light mt-4">
            {data?.userBase}
          </h6>
        </div>
      </div>
    </div>
  );
}
